import React, { useState } from 'react';
import Icon from './Icon';
import Badge from './Badge';

/* Figma: CarInfoBox - side-by-side layout: image LEFT (~45%), details RIGHT (~55%)
   Used across BookingSettings, Payment, and Complete pages for all service types */
export default function CarInfoBox({
  images = [],
  carName,
  usageTimeBadge,
  specs = [],
  children,
  className = '',
}) {
  const [imgIdx, setImgIdx] = useState(0);
  const items = images.length > 0 ? images : [null];

  return (
    <div className={`flex flex-col sm:flex-row gap-5 ${className}`}>
      {/* Image area - left side */}
      <div className="sm:w-[45%] shrink-0">
        <div className="relative bg-mono-100 rounded-lg overflow-hidden w-full h-[200px]">
          {items[imgIdx] ? (
            <img src={items[imgIdx]} alt={carName} draggable={false} loading="lazy" className="w-full h-full object-cover pointer-events-none" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-mono-400 text-sm">
              <Icon name="image" size={48} className="text-mono-400 opacity-30" />
            </div>
          )}
          {items.length > 1 && (
            <>
              <button
                type="button"
                onPointerDown={(e) => { e.stopPropagation(); setImgIdx((prev) => (prev - 1 + items.length) % items.length); }}
                className="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white/80 rounded-full flex items-center justify-center cursor-pointer"
              >
                <Icon name="chevron-left" size={16} />
              </button>
              <button
                type="button"
                onPointerDown={(e) => { e.stopPropagation(); setImgIdx((prev) => (prev + 1) % items.length); }}
                className="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white/80 rounded-full flex items-center justify-center cursor-pointer"
              >
                <Icon name="chevron-right" size={16} />
              </button>
            </>
          )}
        </div>
      </div>

      {/* Details - right side */}
      <div className="flex-1 flex flex-col gap-2.5">
        {/* Vehicle name */}
        {carName && <h3 className="text-base font-bold text-mono-900">{carName}</h3>}

        {/* Usage time badge - Figma: bg #FFF3E8, border #FF6B00, r=28, text #E55D00 */}
        {usageTimeBadge && (
          <Badge variant="time">{usageTimeBadge}</Badge>
        )}

        {/* Specs list — text 없는 항목은 아이콘도 미표시 */}
        {specs.filter((s) => s.text).length > 0 && (
          <div className="flex flex-col gap-1.5">
            {specs.filter((s) => s.text).map((spec, i) => (
              <div key={i} className="flex items-center gap-2">
                <Icon name={spec.icon || 'info'} size={18} className="text-mono-400 shrink-0" />
                <span className="text-2sm font-medium text-mono-700">{spec.text}</span>
              </div>
            ))}
          </div>
        )}

        {/* Additional content (wait info, pricing, etc.) passed as children */}
        {children}
      </div>
    </div>
  );
}
